"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

var _pclnDesignSystem = require("pcln-design-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Container = _styledComponents["default"].div.withConfig({
  componentId: "sc-1lhlgmk-0"
})(["display:flex;flex-direction:", ";white-space:nowrap;justify-content:flex-start;"], function (props) {
  return props.simpleText ? 'column' : 'row';
});

var Typography = _styledComponents["default"].div.withConfig({
  componentId: "sc-1lhlgmk-1"
})(["display:flex;font-size:", "px;color:", ";margin-right:", "px;white-space:nowrap;"], function (props) {
  return (0, _themeGet.themeGet)("fontSizes.".concat(props.titleSize));
}, function (props) {
  return (0, _pclnDesignSystem.getPaletteColor)(props.titleColor || 'text.base')(props);
}, (0, _themeGet.themeGet)('space.2'));

var StyledBadge = (0, _styledComponents["default"])(_pclnDesignSystem.Badge).withConfig({
  componentId: "sc-1lhlgmk-2"
})(["display:flex;align-items:center;border-radius:3px;padding:2px 4px;width:max-content;font-size:", "px;margin-right:", "px;font-weight:", ";background-color:", ";color:", ";> svg{margin-left:", "px;}"], function (props) {
  return (0, _themeGet.themeGet)("fontSizes.".concat(props.textSize));
}, (0, _themeGet.themeGet)('space.2'), function (props) {
  return (0, _themeGet.themeGet)("fontWeights.".concat(props.backgroundColor ? 'regular' : 'bold'));
}, function (props) {
  return (0, _pclnDesignSystem.getPaletteColor)(props.backgroundColor || 'transparent')(props);
}, function (props) {
  return (0, _pclnDesignSystem.getPaletteColor)(props.textColor || (props.backgroundColor ? 'text.lightest' : 'text.base'))(props);
}, (0, _themeGet.themeGet)('space.1'));

var ReviewsLink = _styledComponents["default"].span.withConfig({
  componentId: "sc-1lhlgmk-3"
})(["display:flex;color:", ";font-size:", "px;font-weight:", ";text-decoration:underline;cursor:pointer;align-items:center;"], function (props) {
  return (0, _pclnDesignSystem.getPaletteColor)(props.color || 'primary.base')(props);
}, (0, _themeGet.themeGet)('fontSizes.0'), (0, _themeGet.themeGet)('fontWeights.regular'));

var ReviewsText = _styledComponents["default"].div.withConfig({
  componentId: "sc-1lhlgmk-4"
})(["display:flex;align-items:center;color:", ";font-size:", "px;font-weight:", ";"], function (props) {
  return (0, _pclnDesignSystem.getPaletteColor)(props.color || 'primary.base')(props);
}, (0, _themeGet.themeGet)('fontSizes.1'), (0, _themeGet.themeGet)('fontWeights.regular'));

var SmallGuestRating = (0, _react.memo)(function (_ref) {
  var title = _ref.title,
      rating = _ref.rating,
      maxRating = _ref.maxRating,
      reviewQuantity = _ref.reviewQuantity,
      iconName = _ref.iconName,
      titleColor = _ref.titleColor,
      textColor = _ref.textColor,
      backgroundColor = _ref.backgroundColor,
      textSize = _ref.textSize,
      titleSize = _ref.titleSize,
      onClick = _ref.onClick,
      simpleText = _ref.simpleText,
      props = _objectWithoutProperties(_ref, ["title", "rating", "maxRating", "reviewQuantity", "iconName", "titleColor", "textColor", "backgroundColor", "textSize", "titleSize", "onClick", "simpleText"]);

  var reviewsText = reviewQuantity > 1 ? 'Reviews' : 'Review';
  return _react["default"].createElement("div", props, _react["default"].createElement(Container, {
    simpleText: simpleText
  }, _react["default"].createElement(StyledBadge, {
    textColor: textColor,
    textSize: textSize,
    backgroundColor: backgroundColor
  }, rating, " / ", maxRating, iconName && _react["default"].createElement(_pclnDesignSystem.Icon, {
    size: 12,
    name: iconName,
    color: textColor
  })), _react["default"].createElement(Typography, {
    titleSize: titleSize,
    titleColor: titleColor
  }, title), !simpleText && (onClick ? _react["default"].createElement(ReviewsLink, {
    onClick: onClick,
    color: titleColor
  }, reviewQuantity ? "".concat(reviewQuantity, " ").concat(reviewsText) : '') : _react["default"].createElement(ReviewsText, {
    color: titleColor
  }, reviewQuantity ? " (".concat(reviewQuantity, " ").concat(reviewsText, ")") : ''))));
});
SmallGuestRating.displayName = 'SmallGuestRating';
SmallGuestRating.propTypes = {
  title: _propTypes["default"].string.isRequired,
  rating: _propTypes["default"].number.isRequired,
  maxRating: _propTypes["default"].number.isRequired,
  reviewQuantity: _propTypes["default"].number,
  iconName: _propTypes["default"].string,
  titleColor: _propTypes["default"].string,
  textColor: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string,
  textSize: _propTypes["default"].oneOf([0, 1, 2, 3, 4, 5, 6]),
  titleSize: _propTypes["default"].oneOf([0, 1, 2, 3, 4, 5, 6]),
  simpleText: _propTypes["default"].bool,
  onClick: _propTypes["default"].func
};
SmallGuestRating.defaultProps = {
  titleColor: 'text.base',
  textColor: 'text.lightest',
  textSize: 1,
  titleSize: 1,
  reviewQuantity: 0,
  simpleText: false,
  backgroundColor: '#053593'
};
var _default = SmallGuestRating;
exports["default"] = _default;